import * as XLSX from 'xlsx'

export function downloadAttendanceTemplate() {
  const headers = [
    'Employee ID',
    'Employee Name',
    'Designation',
    'Department',
    'Date',
    'Check In',
    'Check Out',
    'Working Hours',
    'Status',
    'Source',
  ]

  const sampleRows = [
    [
      'EMP-1028',
      'Anitha Kumar',
      'Senior Faculty',
      'Mathematics',
      '24-Sep-2026',
      '09:02 AM',
      '05:58 PM',
      '8h 56m',
      'Present',
      'Manual Import',
    ],
    [
      'EMP-9034',
      'Arun Kumar',
      'Lab Instructor',
      'Computer Science',
      '24-Sep-2026',
      '09:45 AM',
      '05:30 PM',
      '7h 45m',
      'Late',
      'Manual Import',
    ],
  ]

  const wsData = [headers, ...sampleRows]
  const worksheet = XLSX.utils.aoa_to_sheet(wsData)

  // Styling header row (Teal background #146971, White bold text)
  const headerCols = ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1']
  headerCols.forEach((cellRef) => {
    if (worksheet[cellRef]) {
      worksheet[cellRef].s = {
        fill: {
          fgColor: { rgb: '146971' },
          patternType: 'solid',
        },
        font: {
          bold: true,
          color: { rgb: 'FFFFFF' },
          name: 'Calibri',
          sz: 11,
        },
        alignment: {
          vertical: 'center',
          horizontal: 'center',
        },
      }
    }
  })

  // Auto-fit column widths
  worksheet['!cols'] = [
    { wch: 16 }, // Employee ID
    { wch: 22 }, // Employee Name
    { wch: 20 }, // Designation
    { wch: 20 }, // Department
    { wch: 16 }, // Date
    { wch: 14 }, // Check In
    { wch: 14 }, // Check Out
    { wch: 16 }, // Working Hours
    { wch: 16 }, // Status
    { wch: 16 }, // Source
  ]

  // Frozen header row
  worksheet['!views'] = [{ state: 'frozen', ySplit: 1 }]

  // Data Validation (dropdown lists)
  worksheet['!dataValidation'] = [
    {
      sqref: 'I2:I100', // Status dropdown
      type: 'list',
      operator: 'equal',
      formula1: '"Present,Late,Absent,On Leave"',
      showErrorMessage: true,
      errorTitle: 'Invalid Status',
      error: 'Please select a valid status from the dropdown list.',
    },
    {
      sqref: 'J2:J100', // Source dropdown
      type: 'list',
      operator: 'equal',
      formula1: '"Biometric,Manual Import"',
      showErrorMessage: true,
      errorTitle: 'Invalid Source',
      error: 'Please select a valid source from the dropdown list.',
    },
  ]

  // Sheet 2: Instructions
  const instructionsHeaders = ['Column Name', 'Expected Format / Value', 'Description & Guidance']
  const instructionsRows = [
    [
      'Employee ID',
      'Text (e.g. EMP-1028)',
      'Unique identification code assigned to the staff member.',
    ],
    [
      'Employee Name',
      'Text (e.g. Anitha Kumar)',
      'Full legal name of the staff member.',
    ],
    [
      'Designation',
      'Text (e.g. Senior Faculty)',
      'Current job designation or academic role of the employee.',
    ],
    [
      'Department',
      'Text (e.g. Mathematics)',
      'Assigned department or faculty wing.',
    ],
    [
      'Date',
      'dd-mmm-yyyy or YYYY-MM-DD (e.g. 24-Sep-2026)',
      'Date of attendance record.',
    ],
    [
      'Check In',
      'hh:mm AM/PM (e.g. 09:02 AM)',
      'Time employee checked in.',
    ],
    [
      'Check Out',
      'hh:mm AM/PM (e.g. 05:58 PM)',
      'Time employee checked out.',
    ],
    [
      'Working Hours',
      'Text (e.g. 8h 56m)',
      'Calculated total duration worked during shift.',
    ],
    [
      'Status',
      'Dropdown (Present, Late, Absent, On Leave)',
      'Attendance classification for the day.',
    ],
    [
      'Source',
      'Dropdown (Biometric, Manual Import)',
      'Data source. Should be "Manual Import" for manual Excel file uploads.',
    ],
  ]

  const instructionsWs = XLSX.utils.aoa_to_sheet([instructionsHeaders, ...instructionsRows])

  // Style instructions header
  const instHeaderCols = ['A1', 'B1', 'C1']
  instHeaderCols.forEach((cellRef) => {
    if (instructionsWs[cellRef]) {
      instructionsWs[cellRef].s = {
        fill: {
          fgColor: { rgb: '146971' },
          patternType: 'solid',
        },
        font: {
          bold: true,
          color: { rgb: 'FFFFFF' },
          name: 'Calibri',
          sz: 11,
        },
        alignment: {
          vertical: 'center',
          horizontal: 'left',
        },
      }
    }
  })

  instructionsWs['!cols'] = [
    { wch: 18 },
    { wch: 40 },
    { wch: 65 },
  ]
  instructionsWs['!views'] = [{ state: 'frozen', ySplit: 1 }]

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Attendance Import')
  XLSX.utils.book_append_sheet(workbook, instructionsWs, 'Instructions')

  XLSX.writeFile(workbook, 'attendance-import-template.xlsx')
}
